import {Component} from "@angular/core";
import {FUIFormContext} from "./form-context";
import {FUIEditFormContext} from "./edit-form-context";

@Component({
    selector: "fui-edit-form-context",
    template: "<ng-content></ng-content>",
    providers: [{ provide: FUIFormContext, useClass: FUIEditFormContext }],
    standalone: false
})
export class FUIEditFormContextComponent {
}
